import { red } from '@mui/material/colors';

export const colors = {
  background: {
    default: '#F9FBFD',
    secondaryLight: '#FFF3E0',
    paper: '#fff',
  },
  primary: {
    main: '#0C6FF9', // this is a blue color.
    dark: '#2738C7',
    light: '#50B3FF',
    contrastText: '#fff',
  },
  gradientPrimary: {
    main: '-webkit-linear-gradient(90deg, #4224BA 0%, #2A81FB 100%)',
    contrastText: '#fff',
  },
  gradientSecondary: {
    main: '-webkit-linear-gradient(90deg, #F8B683 0%, #F39226 41.15%, #F56600 73.44%)',
    contrastText: '#fff',
  },

  secondary: {
    main: '#FF9800', // this is an orange color.
    dark: '#EF6C00',
    light: '#FFB74D',
    contrastText: '#fff',
  },
  error: {
    main: red.A400,
  },
  info: {
    main: '#53ac6c',
  },
  success: {
    main: '#22BC1F',
    dark: '#209E3C',
    light: '#9EF09C',
    contrastText: '#fff',
  },
  grey: {
    '500': '#666666',
    light: '#adadad',
  },
  warning: {
    main: '#F44336',
    dark: '#D32F2F',
    light: '#EF9A9A',
    lighter: '#f5bcbc',
  },
  gradient: {
    primary: '-webkit-linear-gradient(90deg, #4224BA 0%, #2A81FB 100%)',
    secondary: '-webkit-linear-gradient(135deg, #F8B683 0%, #F39226 41.15%, #F56600 73.44%)',
  },
  component: {
    paperBorderColor: '#d3e0f2',
    inputBorderColor: '#F2F2F2',
    inputBorderColorHover: '#BABABA',
    contrastingBlue: '#EDF4FB',
    paperformBackground: '#f9fbfd',
    adviceChatboxAssistantBubble: '#F0F0F0',
    documentTypeChip: {
      purchase: {
        backgroundColor: '#90C0FD',
        color: '#0A0077',
      },
      sales: {
        backgroundColor: '#ACF0AF',
        color: '#13531E',
      },
    },
  },
};
